let paypalScriptPromise: Promise<void> | null = null;

declare global {
  interface Window {
    paypal?: {
      Buttons: (options: Record<string, unknown>) => {
        isEligible?: () => boolean;
        render: (container: HTMLElement) => Promise<void>;
        close?: () => Promise<void> | void;
      };
    };
    turnstile?: {
      render: (container: HTMLElement, options: Record<string, unknown>) => string;
      reset: (widgetId: string) => void;
      remove: (widgetId: string) => void;
    };
  }
}

export const loadPaypalSdk = (clientId: string, currency: string): Promise<void> => {
  if (window.paypal) {
    return Promise.resolve();
  }

  if (paypalScriptPromise) {
    return paypalScriptPromise;
  }

  paypalScriptPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById("paypal-sdk");

    if (existing) {
      existing.addEventListener("load", () => resolve(), { once: true });
      existing.addEventListener("error", () => reject(new Error("PayPal SDK failed to load.")), { once: true });
      return;
    }

    const script = document.createElement("script");
    script.id = "paypal-sdk";
    script.async = true;
    script.src = `https://www.paypal.com/sdk/js?client-id=${encodeURIComponent(clientId)}&currency=${encodeURIComponent(
      currency,
    )}&intent=capture`;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("PayPal SDK failed to load."));
    document.body.appendChild(script);
  });

  return paypalScriptPromise;
};

export const loadTurnstileScript = (): Promise<void> =>
  new Promise((resolve, reject) => {
    if (window.turnstile) {
      resolve();
      return;
    }

    const existing = document.getElementById("turnstile-sdk");

    if (existing) {
      existing.addEventListener("load", () => resolve(), { once: true });
      existing.addEventListener("error", () => reject(new Error("Turnstile failed to load.")), { once: true });
      return;
    }

    const script = document.createElement("script");
    script.id = "turnstile-sdk";
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Turnstile failed to load."));
    document.body.appendChild(script);
  });
